import './DataMissing.css'

const DataMissing = () => (
  <div className="dataMissing">
    <b>Data Missing</b>
  </div>
)

export default DataMissing
